import React from 'react';
import { Heading } from '../Heading';
import { Spacer } from '../Spacer';

function AlertTitle(_ref) {
  var title = _ref.title;
  if (!title) return null;
  return /*#__PURE__*/React.createElement(Spacer, {
    mb: 0.5
  }, /*#__PURE__*/React.createElement(Heading, {
    size: 5
  }, title));
}

export default AlertTitle;